var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v("Oops!")]),_c('p',{staticClass:"subtitle"},[_vm._v("No estás autorizado a ver esta información.")])])}]

export { render, staticRenderFns }